/* IFDP Magazine motion: scroll reveal + word pull-up. No deps, degrada senza JS. */
(function () {
  document.documentElement.classList.add('ifdp-js');
  if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var h1 = document.querySelector('.ifdp-magazine-head h1');
  if (h1 && !h1.dataset.ifdpSplit) {
    h1.dataset.ifdpSplit = '1';
    var words = h1.textContent.trim().split(/\s+/);
    h1.textContent = '';
    words.forEach(function (w, i) {
      var outer = document.createElement('span'); outer.className = 'ifdp-w';
      var inner = document.createElement('span'); inner.textContent = w;
      inner.style.animationDelay = (i * 0.08) + 's';
      outer.appendChild(inner); h1.appendChild(outer);
      if (i < words.length - 1) h1.appendChild(document.createTextNode(' '));
    });
  }

  var targets = document.querySelectorAll(
    '.article-body .rte figure, .article-body .rte h2, .ifdp-inline-carousel-wrap, .template-blog .post'
  );
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('ifdp-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  targets.forEach(function (t) {
    var r = t.getBoundingClientRect();
    if (r.top < innerHeight * 0.9) return; /* già in viewport al load: niente flash */
    t.classList.add('ifdp-reveal'); io.observe(t);
  });
})();

/* IFDP inline carousel: frecce + drag-to-scroll (desktop). I caroselli inline degli
   articoli sono overflow-x nativo: con un mouse senza scroll orizzontale non erano
   navigabili. Frecce visibili solo se c'e' overflow; drag solo pointerType mouse. */
(function () {
  function initNav(wrap) {
    var track = wrap.querySelector('.ifdp-inline-carousel');
    if (!track || wrap.dataset.ifdpNav) return;
    wrap.dataset.ifdpNav = '1';
    function step() {
      var item = track.querySelector('.ifdp-inline-carousel__item');
      return item ? (item.getBoundingClientRect().width + 14) : track.clientWidth * 0.8;
    }
    function mkBtn(dir) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ifdp-car-arrow ifdp-car-arrow--' + (dir < 0 ? 'prev' : 'next');
      b.setAttribute('aria-label', dir < 0 ? 'Scorri indietro' : 'Scorri avanti');
      b.innerHTML = '<svg width="14" height="14" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="' + (dir < 0 ? 'M10 2 4 8l6 6' : 'M6 2l6 6-6 6') + '" stroke="currentColor" stroke-width="1.6"/></svg>';
      b.addEventListener('click', function () { track.scrollBy({ left: dir * step() * 2, behavior: 'smooth' }); });
      return b;
    }
    var prev = mkBtn(-1), next = mkBtn(1);
    wrap.appendChild(prev); wrap.appendChild(next);
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 1;
      wrap.classList.toggle('ifdp-car--has-nav', max > 2);
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max;
    }
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
    var down = null, moved = false;
    function endDrag() {
      if (!down) return;
      down = null;
      track.style.scrollSnapType = '';
      track.classList.remove('ifdp-car--dragging');
    }
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = { x: e.clientX, left: track.scrollLeft, id: e.pointerId }; moved = false;
      track.style.scrollSnapType = 'none'; /* lo snap mandatory combatte col drag */
      track.classList.add('ifdp-car--dragging');
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    });
    track.addEventListener('pointermove', function (e) {
      if (!down || e.pointerId !== down.id) return;
      var dx = e.clientX - down.x;
      if (Math.abs(dx) > 4) moved = true;
      if (moved) { e.preventDefault(); track.scrollLeft = down.left - dx; }
    });
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('lostpointercapture', endDrag);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); }); /* niente drag nativo img/link */
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }
  function onReady(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  onReady(function(){ [].forEach.call(document.querySelectorAll('.ifdp-inline-carousel-wrap'), initNav); });
})();
